export default function () {
  return {
    list: [
      {
        key: 'takeOverTime',
        name: '合同截止时间',
      },
      {
        key: 'dailyRule',
        name: '月付租金未足月计算规则',
      },
      {
        key: 'isSettlementRefund',
        name: '是否结算应退租金',
      },
      {
        key: 'receivableAmount',
        name: '应收租金',
      },
      {
        key: 'toBeReceivedAmount',
        name: '已收租金',
      },
      {
        key: 'receivableDeposit',
        name: '应收押金',
      },
      {
        key: 'receivedDeposit',
        name: '已收押金',
      },
    ],
    operationList: [
      {
        key: 'operationFlowAmount',
        name: '运营流水',
      },
      {
        key: 'operationFlowRemarks',
        name: '备注',
      },
    ],
    resultList: [
      {
        key: 'operationFlowDeduct',
        name: '抵扣运营流水',
        finance: true,
      },
      {
        key: 'refundableDepositAmount',
        name: '应退押金',
        finance: true,
      },
      {
        key: 'refundableRentAmount',
        name: '应退租金',
        finance: true,
      },
      {
        key: 'needPatchAmount',
        name: '需补欠款',
        finance: true,
      },
      {
        key: 'settlementState',
        name: '核算状态',
      },
    ],
  }
}
